import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

import {
  getPsrCode,
  verifyHaveOnlyPsrMigratedSelected
} from '../../services/psr';
import {HideButtonWhenLogout} from '../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../store/slices/chatStore';
import {useEcStore} from '../../store/slices/ecStore';
import {useInteractionStore} from '../../store/slices/interactionStore';
import PsrCard from '../PsrCard';
import './PsrCodeInput.style.scss';

const PsrCodeInput = (props) => {
  const cnpj = useEcStore((state) => state.ec.ecBasicData.cnpj);
  const listInputCode = useChatStore((state) => state.listInputCode);
  const listCodePsr = useChatStore((state) => state.listCodePsr);
  const psrInputOwnerId = useChatStore((state) => state.psrInputOwnerId);
  const setChatInputCode = useChatStore((state) => state.setChatInputCode);
  const setChaListCode = useChatStore((state) => state.setChaListCode);
  const setPsrInputOwnerId = useChatStore((state) => state.setPsrInputOwnerId);
  const disabledButtonSendMessage = useInteractionStore(
    (state) => state.disabledButtonSendMessage
  );
  const setHaveOnlyPsrMigratedSelected = useInteractionStore(
    (state) => state.setHaveOnlyPsrMigratedSelected
  );
  const [showOptionPsrInput, setShowOptionPsrInput] = useState(true);
  const [showMessageOptionPsrInput, setShowMessageOptionPsrInput] =
    useState(false);
  const [listPsrInputCode, setListPsrInputCode] = useState([]);
  const [haveErrorIntoListPsr, setErrorIntoListPsr] = useState([]);
  const [showBtnSavePsrCode, setShowBtnSavePsrCode] = useState(false);
  const [messagePsrSelectedList, setMessagePsrSelectedList] = useState([]);
  const isCurrentOwner = psrInputOwnerId === props.stepId;

  const showPsrsWithCodes = (psrs) =>
    psrs.map((psrItem) => {
      return (
        <li key={psrItem.id}>
          <strong>{psrItem.name}</strong> - Código de afiliação:{' '}
          {psrItem.idMultivan}
        </li>
      );
    });

  const saveCodeInputPsrList = () => {
    setShowBtnSavePsrCode(false);
    disabledButtonSendMessage('disabled');
    setHaveOnlyPsrMigratedSelected(
      verifyHaveOnlyPsrMigratedSelected(listCodePsr)
    );

    setMessagePsrSelectedList(showPsrsWithCodes(listCodePsr));
    setShowOptionPsrInput(false);
    props.saveButton();
  };

  const cancelButton = () => {
    props.cancelButton();
    setChatInputCode([]);
    setChaListCode([]);
    setPsrInputOwnerId(null);
    setShowOptionPsrInput(false);
  };

  useEffect(() => {
    if (!isCurrentOwner) {
      return;
    }

    if (listInputCode.length) {
      let jsxElementsPsrCodeInput = listInputCode.map((psrItem) => {
        return (
          <PsrCard
            key={psrItem.id}
            psrItem={psrItem}
            psrCodeIsCnpj={psrItem.isIdMultivanCnpj}
            psrCode={getPsrCode(psrItem, listCodePsr, cnpj)}
            haveErrorIntoListPsr={haveErrorIntoListPsr}
            setErrorIntoListPsr={setErrorIntoListPsr}
          />
        );
      });
      setListPsrInputCode(jsxElementsPsrCodeInput);
      setShowMessageOptionPsrInput(true);
    }
  }, [listInputCode, listCodePsr, cnpj, haveErrorIntoListPsr, isCurrentOwner]);

  useEffect(() => {
    if (!isCurrentOwner) {
      return;
    }

    let psrCodeFull = listCodePsr.filter((psr) => psr.idMultivan === '');
    setShowBtnSavePsrCode(!psrCodeFull.length);
  }, [listCodePsr, isCurrentOwner]);

  return (
    <>
      {isCurrentOwner && showMessageOptionPsrInput && (
        <div className="message-line">
          <div
            className="message-receive"
            id="message-show-psrs"
            data-aut-test="message-receive-text"
            data-testid="message-receive-text"
          >
            <div className="message-div">
              <p>
                Também vou precisar do código de afiliação para a(s)
                maquininha(s) escolhida(s)
              </p>
            </div>
          </div>
        </div>
      )}
      {isCurrentOwner && showOptionPsrInput && (
        <HideButtonWhenLogout>
          <div className={listPsrInputCode.length > 0 ? 'message-line' : ''}>
            <div className="psr-cards-container">{listPsrInputCode}</div>

            {listInputCode.length > 0 && (
              <div className="form-show-button">
                {showBtnSavePsrCode && haveErrorIntoListPsr.length === 0 && (
                  <button
                    id="save-sent-code-psr"
                    data-testid="form-input-code-cnae"
                    data-aut-test="save-sent-code-psr"
                    onClick={() => saveCodeInputPsrList()}
                  >
                    Salvar
                  </button>
                )}
                <button
                  id="cancel-sent-code-psr"
                  data-testid="cancel-sent-code-psr"
                  data-aut-test="cancel-sent-code-psr"
                  onClick={() => cancelButton()}
                >
                  Cancelar
                </button>
              </div>
            )}
          </div>
        </HideButtonWhenLogout>
      )}

      {messagePsrSelectedList.length > 0 && (
        <div className="message-line">
          <div className="message-sent" id={`msg-result-psr`}>
            <div className="message-div">
              <ul>{messagePsrSelectedList}</ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

PsrCodeInput.propTypes = {
  cancelButton: PropTypes.func,
  saveButton: PropTypes.func,
  stepId: PropTypes.number
};

export default PsrCodeInput;
